import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutShare24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowOutShare24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.712 7.712a.75.75 0 0 1-1.06 0L12.75 5.811V15a.75.75 0 0 1-1.5 0V5.81L9.348 7.712a.75.75 0 1 1-1.06-1.06L11.47 3.47l.53-.53.53.53 3.182 3.182a.75.75 0 0 1 0 1.06M4 13a3.25 3.25 0 0 1 3.25-3.25h.784a.75.75 0 0 1 0 1.5H7.25A1.75 1.75 0 0 0 5.5 13v4.75c0 .967.784 1.75 1.75 1.75h9.5a1.75 1.75 0 0 0 1.75-1.75V13a1.75 1.75 0 0 0-1.75-1.75h-.474a.75.75 0 0 1 0-1.5h.474A3.25 3.25 0 0 1 20 13v4.75A3.25 3.25 0 0 1 16.75 21h-9.5A3.25 3.25 0 0 1 4 17.75z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutShare24);
